var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaterialControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-materialControl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-materialControl",
    clipPath: "url(#clip-icon-materialControl)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M237.467,291.893l-.229-.229.013-.013C237.327,291.728,237.391,291.817,237.467,291.893Z",
    fill: "none",
    stroke: "#5bac5a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M919.659,132.59H104.341a40.765,40.765,0,0,0-40.765,40.765V305.844a40.765,40.765,0,0,0,40.765,40.766H919.659a40.765,40.765,0,0,0,40.765-40.766V173.355A40.765,40.765,0,0,0,919.659,132.59Zm-44.56,122.3a20.383,20.383,0,0,1-20.383,20.383H633.771a20.383,20.383,0,0,1-20.383-20.383V224.313a20.383,20.383,0,0,1,20.383-20.383H854.716A20.383,20.383,0,0,1,875.1,224.313Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M919.659,404.99H104.341a40.765,40.765,0,0,0-40.765,40.766V578.245a40.765,40.765,0,0,0,40.765,40.765H919.659a40.765,40.765,0,0,0,40.765-40.765V445.756A40.765,40.765,0,0,0,919.659,404.99Zm-44.56,122.3a20.383,20.383,0,0,1-20.383,20.383H238.52a20.383,20.383,0,0,1-20.383-20.383V496.713A20.383,20.383,0,0,1,238.52,476.33h616.2A20.383,20.383,0,0,1,875.1,496.713Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M919.659,677.39H104.341a40.765,40.765,0,0,0-40.765,40.766V850.645a40.765,40.765,0,0,0,40.765,40.765H919.659a40.765,40.765,0,0,0,40.765-40.765V718.156A40.765,40.765,0,0,0,919.659,677.39Zm-44.56,122.3a20.383,20.383,0,0,1-20.383,20.383H466.8a20.383,20.383,0,0,1-20.383-20.383V769.113A20.383,20.383,0,0,1,466.8,748.73H854.716A20.383,20.383,0,0,1,875.1,769.113Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialControl);
export default __webpack_public_path__ + "static/media/icon-materialControl.0b6f69c2501db32a4b8943dbeb7a6022.svg";
export { ForwardRef as ReactComponent };